var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserEmptyDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 140,
    viewBox: "0 0 220 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3851_1193113",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: -10,
    width: 160,
    height: 160
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: -10,
    width: 160,
    height: 160,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3851_1193113)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110 67.9489C103.564 67.9489 98.0667 65.6689 93.5067 61.1089C88.9467 56.55 86.6667 51.0522 86.6667 44.6156C86.6667 38.18 88.9467 32.6822 93.5067 28.1222C98.0667 23.5622 103.564 21.2822 110 21.2822C116.436 21.2822 121.933 23.5622 126.493 28.1222C131.053 32.6822 133.333 38.18 133.333 44.6156C133.333 51.0522 131.053 56.55 126.493 61.1089C121.933 65.6689 116.436 67.9489 110 67.9489ZM60 108.591V103.897C60 100.633 60.8867 97.6094 62.66 94.8272C64.4333 92.045 66.8033 89.9061 69.77 88.4106C76.3589 85.1806 83.0061 82.7578 89.7117 81.1422C96.4172 79.5267 103.18 78.7189 110 78.7189C116.82 78.7189 123.583 79.5267 130.288 81.1422C136.994 82.7578 143.641 85.1806 150.23 88.4106C153.197 89.9061 155.567 92.045 157.34 94.8272C159.113 97.6094 160 100.633 160 103.897V108.591C160 111.402 159.015 113.793 157.045 115.764C155.075 117.734 152.684 118.719 149.872 118.719H70.1283C67.3161 118.719 64.925 117.734 62.955 115.764C60.985 113.793 60 111.402 60 108.591Z",
    fill: "#383838"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserEmptyDark);
export default __webpack_public_path__ + "static/media/user_empty_dark.492965b3f42aef2030b1924b3fc33052.svg";
export { ForwardRef as ReactComponent };